import React, { Component } from "react";
import { AppContext } from "~/scripts/context/app";
import classNames from "classnames";

class Logo extends Component {
    static contextType = AppContext;

    render() {
        const { theme } = this.context;

        return (
            <svg
                className={classNames("logo", `theme-${theme}`)}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 368 140"
            >
                <polygon
                    className={classNames("logo__element", "logo__e")}
                    points="0,0 71.28,0 71.28,21.07 24.31,21.07 24.31,34.61 66.85,34.61 66.85,54.15 24.31,54.15 24.31,68.33 71.91,68.33 71.91,89.4 0,89.4"
                />
                <polygon
                    className={classNames("logo__element", "logo__x")}
                    points="133.68,43.93 104.56,0 132.8,0 148.5,25.16 164.32,0 191.92,0 162.8,43.68 193.19,89.4 164.95,89.4 147.99,62.45 130.9,89.4 103.3,89.4"
                />
                <rect
                    className={classNames("logo__element", "logo__i")}
                    x="228.25"
                    width="24.69"
                    height="89.4"
                />
                <polygon
                    className={classNames("logo__element", "logo__t")}
                    points="316.1,21.71 289.52,21.71 289.52,0 367.25,0 367.25,21.71 340.66,21.71 340.66,89.4 316.1,89.4"
                />
                <rect
                    className={classNames("logo__element", "logo__underscore")}
                    x="103.44"
                    y="114.58"
                    width="89.61"
                    height="24.9"
                />
            </svg>
        );
    }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/scripts/elements/Logo.js